import { useCallback, useEffect, useState } from 'react'

import { Alert } from '@avantstay/backoffice-core'

import { TaxonomyTask } from './CaseTaxonomy.types'
import { getTaxonomyTasks } from './caseTaxonomyServices'

export const useTaxonomyTasks = () => {
  const [tasks, setTasks] = useState<TaxonomyTask[]>([])
  const [isLoading, setIsLoading] = useState(true)

  const loadTasks = useCallback(async () => {
    try {
      setIsLoading(true)
      setTasks(await getTaxonomyTasks())
    } catch (error) {
      Alert.Error((error as Error).message)
      setTasks([])
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    loadTasks()
  }, [loadTasks])

  return { tasks, isLoading }
}
